import { reactive } from 'vue'
import { api, ApiError, type AccountUser } from '../api'

// Who is signed in. The server is the source of truth; this only caches /api/auth/session.
export const session = reactive({
  loaded: false,
  user: null as AccountUser | null,
  get signedIn() { return Boolean(this.user) && !String(this.user?.id).startsWith('guest:') },
})

export async function loadSession() {
  try {
    const result = await api.account.session()
    session.user = result.authenticated ? result.user : null
  } catch (error) {
    if (!(error instanceof ApiError && error.status === 401)) throw error
    session.user = null
  } finally {
    session.loaded = true
  }
}

/** Visitors grade answers under a guest session; create one on first use. */
export async function ensureSession() {
  if (session.user) return
  const result = await api.account.guest()
  session.user = result.user
}

export async function signOut() {
  await api.account.logout()
  session.user = null
}
